import BMW from "../cars/bmw.png"
import mustang from "../cars/mustang.png"
import lambo from "../cars/lambo.png"
import lotus from "../cars/lotus.png"
import ferrari from "../cars/ferrari.png"
import ev6 from "../cars/kiaev6.jpg"
export const CAR_DATA = [
    [
      {
        name: "KIA EV6",
        price: "60L",
        img: ev6,
        model: "BMW 3",
        mark: "KIA ",
        year: "2021",
        doors: "4/5",
        air: "Yes",
        transmission: "Automatic",
        fuel: "Electric",
      },
    ],
    [
      {
        name: "Mustang",
        price: "150",
        img: mustang,
        model: "Ford GT",
        mark: "A1",
        year: "2012",
        doors: "4/5",
        air: "Yes",
        transmission: "Manual",
        fuel: "Gasoline",
      },
    ],
    [
      {
        name: "Lotus",
        price: "200",
        img: lotus,
        model: "Camry",
        mark: "Lotus",
        year: "2006",
        doors: "4/5",
        air: "Yes",
        transmission: "Automatic",
        fuel: "Hybrid",
      },
    ],
    [
      {
        name: "Lamborghini",
        price: "250",
        img: lambo,
        model: "Hurricane",
        mark: "Lambo",
        year: "2012",
        doors: "4/5",
        air: "Yes",
        transmission: "Manual",
        fuel: "Diesel",
      },
    ],
    [
      {
        name: "Ferrari",
        price: "300",
        img: ferrari,
        model: "488 Spider",
        mark: "Ferrari",
        year: "2006",
        doors: "4/5",
        air: "Yes",
        transmission: "Manual",
        fuel: "Diesel",
      },
    ]
  ];
